import { ChakraText } from "../ChakraText";
import { AjaxError } from "../../HttpService";

import { ServerError } from "./components/ServerError";
import { NotFoundNotification } from "./NotFoundNotification";
import { WarningNotification } from "./WarningNotification";
import { NotAllowedNotification } from "./components/NotAllowedNotification";

interface FallbackProps<ErrorType> {
  error: ErrorType;
}

interface IProps extends FallbackProps<Error> {}

const ErrorPageStrategy = ({ error }: IProps) => {
  if (error instanceof AjaxError) {
    switch (error.status) {
      case 400:
        return (
          <WarningNotification>
            <ChakraText fontSize="3xl">{error.message}</ChakraText>
          </WarningNotification>
        );
      case 401:
      case 403:
        return <NotAllowedNotification />;
      case 404:
        return (
          <NotFoundNotification>
            <ChakraText fontSize="3xl">Nie znaleziono strony</ChakraText>
          </NotFoundNotification>
        );
      case 500:
        return <ServerError />;
      default:
        return <ServerError />;
    }
  }
  return <ServerError />;
};

export { ErrorPageStrategy };
